import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function TiposDocumentoHeader({
  total,
  activos,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  activos: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Tipos de documento adicional"
      description={`${total} tipos (${activos} activos) · catálogo obligatorio para clasificar los documentos adicionales al subirlos en el paso Documentos.`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo tipo
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
